var _style, _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhitefont(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 578 98.7",
    style: {
      enableBackground: "new 0 0 578 98.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:url(#SVGID_00000132777800002220389760000012302461670737700787_);}\r\n\t.st3{fill:url(#SVGID_00000174564144244098740830000005490036671063901600_);}\r\n\t.st4{fill:url(#SVGID_00000090979791865282990550000015656437597964633493_);}\r\n\t.st5{fill:url(#SVGID_00000111874990053540801250000017623238297099420547_);}\r\n\t.st6{fill:url(#SVGID_00000117648343199647204270000002938038750456897456_);}\r\n\t.st7{fill:url(#SVGID_00000157299668424617976930000001193390515402762165_);}\r\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 44.8096,
    cy: 50.66,
    r: 48.9039,
    gradientTransform: "matrix(1.0185 0 0 -1 3.7114 100)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#474747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2413,
    style: {
      stopColor: "#434343"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4766,
    style: {
      stopColor: "#373737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7096,
    style: {
      stopColor: "#242424"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9399,
    style: {
      stopColor: "#080808"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.6,98.7c-4.7,0-8.6-3.8-8.6-8.4V8.4C0,3.8,3.8,0,8.6,0h81.5c4.7,0,8.6,3.8,8.6,8.4v81.8 c0,4.7-3.8,8.4-8.6,8.4L8.6,98.7L8.6,98.7z"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 397,
    height: 397,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYwAAAGMCAYAAADJOZVKAAAACXBIWXMAAC37AAAt+wH8h0rnAAAg AElEQVR4nO3dbW/USNbG8VNRM1EvmdUkw60dCC/5/p9o3i0dZrUhQRC2FYhSt9xP8UPZLqdz3L56 /j8JSNvV9okp13G5/BBMwMfF1aWZzd9fvvtTJN4LMyv+LN5fvltOIKROavEurj7NzayoEzeX797e TCCkTmrx2rpOfDCz5fvLd4sJhNNLNF5TadO2TqYRBgBg6kgYAIAsMzYTFIUgcTZ1RSlWoAs9DMih AQYOg4QBAMhCwoAslX4G/SEcC8YwIEfulFQIJA0cBXoYAIAsJAwAQBZOSUH2qiO1MYx44DiG4Eo0 pJAwIEeuLQuVfwBZJAwIEs0YgDjGMAAAWehhQPJ8tVLEiv0LxjCQQsKAHNUxDEAdCQOCyBjAIZAw sEKThjLqA1JIGJA7X03/YgSMYSCBq6QAAFnoYUAPXQzgIEgY2BF6h90EYhhC87JlpUeZYBwkDKyb M46CURbMAhkDNSQMyA1w0r8YQ+AgAg0kDOghYwAHQcLADmMYXsgYOA4kDDw1Z7Rr2AiMeiOBhAG5 UW/6F2Ng1BtN3LgHuhbeZDcv9QJV9DCgR/FxtbS9OAIkDNCWoYE6gRROSeEJrQS2qAtIoIfhROoJ sKqD3iIha15xpDXoXexvMTJI742E4UDv9ZZi8Uq+83QCMQwm9gQAHsnujoQBQSRk4BBIGODGPTRQ FZBCwnAk00UWyxj0L0bArd5IIGE4YAzDGZt3JEIXQjB+MQouqwUAZAkfF1cXAptqvklu3w8dSNeR TGnefPPnWzD72XZncvVq1tCc1yzUnN+xjJzlbKbu4rVVvO3Ly1hl13raDTtAfGVmv5qFpZkts9cx ksSJnFdm8ddNrMtBUbScFWo/WZSYE/u+kyxUtAsP0exrTvn0smNjRrNcbCvaWEZyfozb6at4rRRv 22W2E7n8dtvu3hw4jiG+FQnjg0CgN5sd7fKQQWQmi6dp1v4Yi95kkZMEmoWbZXKX01M2r0jGOvpX kfUFxRMQrQ3ifgvIX27snFud09vQl+b0JY2sdXctpz9ptM2beNJQs5iJZLji6Pf1IWMdmCzmq6P2 ENZH7PXy1tPQ9/U6Oso0Z2Uc7YdyDyM04u1ZnVOi6EwQmx7GM47YnxPP/m3LKt6QiDc2AuhYWUgX S09OTA1PH0OjfO17Ia6P2OP6iL2z/OYGv5Bs1MPTCmNlSno5MTW/a97uoOwixNjoEbXd0DeBG/0U exgPs/eX7yYf8MfFVdGzOH1/+e7fEwin16e//nOxaYC/vv3jX/s1aCO4/nyzi/fN7xeTj/f29st8 mzDOz3+bfP1Vi9ee6sTPN28uJOJd7XMh/Hz3x78k4t0OBSi0v2VcJQU9XCUFHAQJAytiD4GYQAxD 6GUMchxSSBiOVHY6tUvYSRcjEKwTDGP74z4MB6F7vHnikQOCeEfVKOhheJB7OJPorqa0eRUfby6F d5CPgYThQrMBlolacfNyimcE9DG8kTDAboYk6gXqSBiOpHY4oWCD3DVdgk0vPSIkkDAcyA14cygJ dQxhjIKE4UHzEimdmLmuFqmNTMZwR8Jwodmi0a5hqziNxqA36kgYYDdDEvUCdSQMJ+xsvpQGkrex RoZl3TDoPQ7u9HYg+ygImSEM1ftcpC5Fk8NBmj8ShhehBpg9DUlc6YcaTkl54LpaX1wlNQIeDYIm EoYLHhYObTzcBimckgIAZKGH4YQnm/vh0SAjELvsiKukxkEPw8FuCINBbygTG4ajGvujh+FB7n0Y Yhj0RmojM+jtjoThglMm0KZZJ6jH3jglBQDIQsJwxMC3L4aIwDYeF6ekHJAofOmdLhE8wcOjQZBA D8MTNRgYB/vaKEgYHkL52loAo+x07G7uOCXlQq/m8iRVR5Knd4Lg49jJGN7oYYDLapFEvUAdPQxH 7G4+6GAgtY25bc+fTA8jBMEnwCpd96n0KBM5opcc8WgQN2rt2ZZED4NkgcQWFkOFcKd2ebhg0mAM wwPPkgJwhBjDcMPzpNwwiOFO7yopDs7GQA/Dxbry6gxhsLOhiXqBOnoYTtjVfCm+MZ2rePywv42D HoYD2Xf+iwSu2jhIxc1Vc664SsqZ3AZWPASWwSAGEptYrAvHVVJOSBYA2O8OjzEM7MidMlFBQ4Yj ET4uruZT+VXqPYnS5zdmdhrMFlYvU/2re9qLle1a9so/zexXs3AdzO5TBSu/Ra1BaVydkmhwKmVa GqSc5Wwm7+K1ZLxti2hfYP7kntY0Pft0Uye+mdnXAUsbReLMSGu8K72nUpoFWr+SOSNZrDrx0iwW deE6d13Jy3AHlmnMT36Mie89xVv/bkxMaGyN5iIr8/LKp8vG+kJj3MS7slhPSqw5Me3A7ouE8WEK kaROO5Wm3QSz5aoS9ySM1gTSNj1xW/aQhNF+j15bUkhcrFhp+wcmiz3KJH6LnmVmLzBj8rMSxXOL HVT2bu+eOAYnjXoT3bsO76TRljCSkbYlDBuSNPZPGM1pu6RR+iiRMBbFKanlBAJpqCWQ4gjtlYVQ ibWtwd9rvc2FJz72JotXYX26rzjieZxisqj9Zq9sG2+wx44QByWKwT2KjP/GTZGTTZ14MLOf/d8a uJIs+TtzqMXb+s1yaMlCzQKhrXhyRnVicpz4aeJ8VXct3K8nJ5r5xDqSN/yFYWUa8yvzih83E6rL nQezx7iKt1K4VKz6hcanEBOLXU8Pcb+yoZk0tmd2Vm1a0d7VE0Rq2oE9Spxd/fTpr6JnMX/7x7/+ nEA4vW5vv1yYWfFncX7+2yQTctnd3fcLC+t4z16/nny8y+Vyvj5lYjfz+fxmAiF1Uou3cPf9+weL tjw7e72YQDi9bm+/FGdKlufnv0nE++mv/3woehlv3/4h0aZtMejtSSIdC8W5oxaw3AZeEw1bhuBl tRoJQ/EmF3Y2YDzsb6Ogh+GhfXBj+iErUerBqd1UNoEYMD0kDDckCzeKrRktsDPBrCyIhOFC8Tmf JDgvmrlCK+qnq6c0qKY3nVe0TiCGXCQLYHxStVh0l9N4lpTRpo2CbQyMRnF34/HmnpQGZUkWKFOr E4oDcYL7nMhltaZXI2iAHTGKgWPYzHr1QqSHQbIYA80atqgLSOEqKXBg5o0DCBwJEoYTzRfoc2mt B93LanUu/Ew+0HDCVC+r1XlF6wRiyKWXLPSuuQdbuk7zIE0Ll9UCwNg0L5LislpXaudNSMrYopPs TDNjaCQMLqv1RaJACkkDNSJjGCQLKG9gKgRSuA8DojgjhTLqAlK4rBbch+GN+zBwJHharSMu8/Oj 1COi9+ZPbV9TrQ/0MJxwL4Yf1Z2NJs0XScOfzn0YQkgWAI4Rg94AMDZeoOSMRzP54kQ7yngfhjPN nY0b97ywswHj4kywOwa9PQhWBIYLPfGWdxzHVuYFStDdukrX1QJHgB4G9DCeBRwECcMRN+754IQU mtuYFyiNgTu9nZAsgHGxz/mjh+GA17NCH/XBVfE6DMEuBm/cAxsXQBbu9PbEjXtQxUCRM96454cb 93yRKJBCvUANPQwPojfu0T5gS7Iu8HgQd9y4B+Gty517ntjrUMdVUhDEVWjAIZAwoIcBWYjjxj1n HFMCYF87LHoYTtYVmGrsgQ4GUls5SB6za+EVrQ50kwVNG7aoC94kW4iPi6sPg74QQuvn9e0S9c9W 2TSh/rk6I/m9YPbNzO4t2JtKc/z05fKP5WgT09NlQ/XDs6dbPWEki7Wtq29e+4x05QsZZZ5Ttn3l z9sJ+rbl8ascGzcOlIcfOcfGD/3LGfKdZtlmub7lta8m9s5/zrzGwwnjgOmNH2N6WvOfXdnq2nOm xfoiW8tUf+fqbxpj4v8mMS3DYlAPo54shqp/O91wt9yo13rzXltMqSc6pZ/y1NX4905PFkutObGg zIZ2eskiJL8zvHaE1gX83e4Lqfy+jV9++NZILyurFiTWnVO2o863LK99Nf199IwQG/PanvGWNX1Y 05OcNmQR+StNLDhUf6N92+2+iCbn+vrzpQWbv/n99z8V4r27+35hZhcWbHH2+vVyAiF1ur//UcRa xLw4/eWXycf78PAwN7NLM7uZzWY3Ewipk1q8hfsfP4ozD8vTX35ZTCCcXnd331fxnp29loj3+vPN h6JfoNKmbfFoEAw8DQVMEJV3FDwaxItYBWZ/Q5lkfaASu+PRIB4IF0eAeuFNbwvTwwAAZOHGPUcc oXlR68IFzedAADUkDCckC0eKG5cK4SqIPZtJLd4tTklBlkob/He7p+RQ2Mb+ZHoYSpWBiutLdftS L6COHoYrmghgHHqXJiq2DjoPH5TbumoBc+IEZdQFNNHDcKGYLAD1esENUN6EHg0CtjNGQ11AAj0M rNFAoI464Uhz45IwPCld9wkoow6PQihhcH7SE0PeKKMuIIUeBmgckMSFid54+KATehcAcGj0MABg ZKrHlCQMAEAWniXliDNTnni6GKpbmCfI++Px5k5oIhwFxrSAQ+CUFOCMfDEOHmTiT6KHQUWA+val TuAY0MNwRTMBjIPTlGMgYQAAsugkDO7iBICDooeBEpIcthgpQhMJwwU7G4Dj2+V4gRIAdjxkoYeB p4aB9gFABxKGJxpgqKLuIoGEgTUaCNTxuC7UkDC8sLMBODIkDOyQN7BFXfCmuYVJGFihgYA8KrE7 oYQhVBuouDgCVGPU0cMADQOALCQMABgZ7/QGAAyglzZIGI441QPgmMgkDBpfAG1oH8YRPi6uLkPt pfrlz8GqL90P1b/Sn5Nl2pdRnR1qy1h5DBYed6+UDa3lnqampmWVLU1om54sUpnwqog1mN0XsdcL Nyt36HmcU9/83DLNIDb/vNps20289a80fvsBcuMapDjQOTWzBzP7WV56eMGV7CPG4stxu4REvC+w jt0Psbtg53crn8rmm7pwn1k+sdx02b4yWfNjY8o8buOtzWsWffohta50+dqc2D6tUrZ92nwTwbK6 vNLCYvNzTplq/PXfp/tzrNWl2ufr2aZiOMjfczNK3phZsWEv92p1RmxMNqs6HW+NwyU2RyLePTea 73MNZ+s/00oWtoklxlBv2WY+79FvrOelvnEytH3IWW5fmeG/zc463j0WsNfan/dVp/bXxUlReRfu q9l7Rw5vzOyiL9YwKEntkdD6J/zTzH4tMvL2CK31q71x5MTZ6OcMXWRrvPtxa8GLxFbUiW9m9tUm liy2SkmjEe+LLH+fdrF/IZebunD9rDW/SHCDlt8a79BQKuV7vly0IzF76ZWFXW7+XTwryFz15e63 nvvZ+8t3S4cwX9TN7ZfVaZLz898mH2vhf8vl9qjhfj6fTz7mh4eHXbyz2Wzy8T4+7s6a/Tw5ORGI N273Uol4bV0nin8eFepDYblcFm3ho8L+Vri9/bJqu8/PzyXi3eIqKQjTGOoMtfE6QBUJwwFNg7ew Phmg9LQYkgaOgMMA3MtjN0OZUqIoU40b2KKHAQDIQsIAAGQhYQAAspAwAABZSBgAgCwkDFdcFgPg eJAwABwBDs7GQMIAAGQhYQAAspAwAABZSBgAgCwkDAAYm+gYPQkDAJCFhOGGy/wAHBcSBgAgCwkD AJCFhAEAyELCAABkIWEAALKQMAAAWUgYbuKR/l4A/q5IGACALCQMABib6AkIEgYAIAsJAwCQhYQB AMhCwgAAZCFhADgCXMY+BhKGKyoxgONBwgAAZCFhAACykDAAAFlIGACALCQMAEAWiYTBtUYoi3H9 R41izEAZPQwHtAve1ltYqQFex0rNgLYZ/3/QpNP4kixwLMLHxdVFCKHy65Q/h/WE2ufdX+nP9e+E ypyOZax/CJWCqx/mYd0b+t5VrjTFqj+G9mmNspUF1manlpOcUMQ7N7NvZvaz/L3qlu5aV+786sz0 /FrZ5rLmVom3Wb5/udnregmvzOxXM1uu/wQLL7yCl7JJFrV4X3D51b+Gf9dau2oXZvZgZl+rZRs/ dCzXWhNlbBbMnt8Sy0UsxVsv1BZ/ehWx/rE5NbaUrpdtzIrbHy42n2/KBWLtQ/1zdZHpMvWtFeu/ W/lzrP6usVYXap+/zTYVw1fct8UoNmoodrTLzlIWq4ngxcrWwu+fsPVr77J6N07Oxnsqk7Wp2ws1 4h0SxQFsE91qJ5ha0kj0LHbxvsjy/RfS0j5krNm7Q5VefjLeoaEMKR8Hlk7wbX/rq9zv/2VZbOCb jILPkN/E9JcMxU72ehXrPi3XeK3ePK57GYkj9knq6GHsucHjs7snXWpH7OsYp5Q0asnCrYfxXBnt RqWHMea6n9mmPcW7V6MYOz8O+WqPbaK4ecZ3D+Vh9v7ynVPCeDk3t7eXZuH0/Py3f0891sL/lsuL TQP8dT6fT6KB6PLw8LCLdzabTT7ex8fH+bYBPjk5mXz9VYvXnurEz9lsJhHvcr3P/fzHfC4R7+3t l1XCuDg/l4h3S+YqKYYMAbShfRgHl9U6ohIDOCYkDAA4CL1DShIGAIxM9ewDCQOcOgOQRShhKD0H YgIxAHuiGqOOHgZWaBwgj0rsjoSBHfY3bFEXvGluYRKGF6X6QOsAIAMJA0AaBz2oIWF4YoeDKuoD EkgYKD+TGQBaaSQMGjLgANjxUEUPw4XijkbjAIxKcJcjYaCEpIEtDnrQpJMw5OoClRfAcaGHAQDI QsJwRS8DGIfYvibaNEgkDLVtS5rwFUXrBPUC6uhhQJZKA0yiGAcHlv5mgjFLKCpD+LtvBC9RbOuS MXAkZBIGF/lBd+tSE7yxhcfBKSkAQBYSBgCMjHd6u+KSOQA4NHoYIL8hiYcreNPb84QSBr0MTyQN lFEfkEIPw5PYjQI0EpBF5R0FCQNr7HCoo0440ty4vEAJbGc0UReQQA/DBQ8pwDGgHrviBUo+VtuV KyCc8Xg8lFEX0EQPA8AR0OtdKKZkmYSh+eQgjtI8qPaFqA1Qx9NqIYvHm4PtPC4ShhMeb+6I7gXE qVYHEoYj2ggvauerqQne2MLjYNAbAJCFp9V6IFwcAeoF6uhheCFpQJhkfeBeLXezj4uree5KQgjD Pq+/VPu8++tpULg+rf452omFaNefb+a12YnvPU2vFalOK02vTK38OGx66eOrzcfTu+/fa8Wa3+2a 11xF1/eTv1xHmc2caK/W/9jpjx8/WksOW3+fnN+11elmxquHh4fs+ntAg+JtNCOxc27+smJyatd3 Tu7vf8y7yjcX2SybnpW4+Dwxv/1Xj6l5J3d33+ct81LfKj14M2N6ajmN2dES/+xuvKhvnevrz/Pq tFgb8kp9rz4tUSZWf6NYG0erf850Hz4urj7klq4nhPq0rAQxMGFsfrqxYEuzcNm57NoPzeQwLGFU 5mVPr00cnBT6GuSXThhDyw6JYfhynr+s49CdG0ZNFr3fedFk0fJheDJpNP3tCeOZ09sTQ7Vs47dM NPJW3xqJhr/5u9Z/x3qScUsYi+IqqWVu6WIlqaSR/f1aY5C69HQ17emv7eTT9VFwXLZ8I7m2WE8Q yWm1qe2Ly5q+/hhfmYVi296b2WO1WOkLmdfeVos1v59eTHVm96o28Ua7t2CP/WHlxjDgN9vW31D5 sc3J5qj9wcx+Dl7t+HrjfcleRfvXByWL+bruxvvOsnucVclOFnnf3cRr920FE6kkf3rqq20BtpSt TZ5vJne0vzkrTXRbGgnlxTxKHMxdX38uehbzN29+/3MC4fS6u7u7MAsXRUY+O3udnZAP5f7+voi1 iHlxevrL5OPdnNYp6sTNbDa7mUBIndTitVWd+PHBLC5PT08XEwin193d91W8Z2dnEvFeX39endlR adO2dB4+KKT/+GiqFGOGD+oCmrhxz8nm1NRR/m6HRipGagtrHlhq4eGDgDPqrj+28TjoYTiiEjvh UBLiVKsECQOCMq6jmhyyBvTxaBAIb12VyDW3MHsd6ng0iAfBPS3SQKBEsi7IBa23lTUSRjS9jasU LpkCKdQL1DCG4YmkAVVcWOBM86XeOjfu0aA5YuMC6McYhgO9W4iMUQzUUB9caXYwuHHPi2bSAHSx z/ljDMMRFdgHp9fR3MZaW5kb94CxcN8ecBDcuAfdrct9e8Co6GF4eN7bhA4esg5OSnkjx42BG/d8 cOOeL1oHHAOOI9zp9DB4CYIvkgbKaHydae5w3IcBAGMTPUDjFa0OePcXgGNED8OJZtLQiJn0Nga9 O725F8OfzBiG5hAGTZsXhodQ3cYkizFwWS30rgLmAohRkOhQR8LACo2DI5IFjoRIwhA7Bha8cU8L FxXgGHDjng9u3PNFe4YU8jJqOCXliaQBVSQLZ7xxzw1v3ANwVHiBki+tg3UOz3AMuA8DVZySclJU 3sALG1yQjsdAsvDEfRhoUKnEcu8j4j6MUXC8jjpeoORBdE+jgXBCssCR0OhhrO5rEEwa3IvhhJNS OIbNzH0YKFN6hShtGuq4LNwRl9W64bLakbCNsUVdcMdltY442AFwNPudaCPBVVIu1hfVKsWrhBGM MSjWCS4N98YYhhsqrxvFMRfGiZyxccdAD8PD7gopkoYrpYsKxND8IoUehhf2OGBc7HPuRO7DiGZB 8KYGpSNgXrnniDs53Une/a8XdPi4uPowgTgs1BJC7fO3YHZvIbyplKn+1T3txco+/RAaX3qaEKof 09Nr323MTTTiofqF7vktZSy9dTqWOahAx+SerLTf7OcveC/P2+mzvtVZKHZ86ltGz3dbvpO7jmTJ gWUa82P9x8aEznmxpXBjSzTKP03ft2xlWmxugZhIIKlpB7SYbA+j2FDlpLG+2bva09jdAB5e7hC5 MvxQWm714/qH2sfKUiqPHiwVbDySsPTdxtzEr1Upk3gI1LYadpWpTo71BSSWWZ7UUaB3ckvBnuWk ZncUSzjsTjdo7QOSRGfx5ySK5MSe64+kkkV1mQdLFpkmlixWJE5EXH3669LM5u/e/vHnBMLpdXN7 e2FmF2ZhcXH+23Li4drd3d0u3rOz15OP93/L5dzMijpx84/5/GYCIXVSi9dWdeL7B7O4PDs7W0wg nF43t19W8V6cn0vEe/Xpr9WZHZU2bYtBb1ca5yhj/3Ek/nZ4YDiauKwWOzK7HGPe7mh+kaLxLCm1 qwnY24Dxsd+5k+lhkDQccVmtM1oyd4q9OMHLahnDcCDZPESdwGl+RyBUHxQpJgtjDMOP3EG7GO4p A9t4fPQwXGhdc6R2PQzGQb1AHT0MN1p9DKnGgSEMd3rJguQ2BnoYHnZ1l0oM4HhwWa0XcoWjKDgq yyiyO7ULKQXbNS6rdbB72pLOIMYao/ROOOBx98znNR0sXK6SQp1cleCyWhf0K/yxjcfBGAa4GgZA FnoYLvTO8XCVlDO5BxWwkdFED8PDbnyTCgyqwTjEBjFEkTA8UYGBcbCvjYJTUg7kTkiJBfz0VkEV om8b4XmfqCFhOKKB8KV21bIU6gISOCUFAMhCD8MFz5GCNq6SQgoJw0NUus1bEHfuIbWR2c7uOCXl YHdFLSfZoUzsUV1UY3/0MJww4O1H7XSJ5OkdBr2RQA8DAJCFhOFC7QiYIzRUadYJarE3Tkl5kBv0 FruxjEHvEfB8czTRw/DCoDcwHurwKOhhONC6C2ODHQ5ljNMjgYThhMrrh6uk0NzGGAOnpMCgN5Ko E6gjYbhQHJXlOBhPouRhBDXYG6ekPMg+GoSXerugHRsBV0mNgR6GAx4NAoyMfDEKehhOeDSIHwa9 R8CjQZBADwMMeiOJOoE6EoYLHqzgSjXDSfXiFJHivHFKysPuHdlqgxhitxsyRuSIR4OgiR6Gg1ge +JaLHBBEvhgFPQxHMgfAUatvwVW1I2DQGwkkDKzoPZBdCeNZOA4kDOghXwAHET4uri4FNv3j5s/B ElwI6ZM2LdNfhSLWEO43cT+Vr/zQ/G7om5deUMsyMpaznvBqvW2b8bavd8Dye2d0F0x8rRh7OzWz BzP7mbvU58ez8fyGvzXe9CIzV5Qolr282LumuVl8tGj32cvvXGZ1kKGvTHN+rBdpxhvjY7RqvKuv xJa1tUwfyXyzmuUhgxjoelYKfMpuNhv2YMmtqFyp5LCtdPV566eDxFNLTLftBVS7q6hC7Xsd89IL Sqy7PL+5HEsv67Re1mo7b3NxlbktU1qLtqjuyLE9Kc32OogYub2IyXgHBNFSdGiS6F5rpcU+2bYP neX7EkXWunuSRdc6NvtgLMX7NGuSyaJMof3dOikq72IasXR6Y2YXh461LWkk/NPMfo1m1yHG+3rS sEpiSKynMi/2N/YtScM6llNb1ipei3ZtxRFaIslUVpcMJD2xdUnZyaNeeOU0rupE+GZmX7MXM6Ja xKdmsajDlXizDUoULXP6exT1Qpe2Plq/3qtXUZvpmCx28T7NmvS5wO3Br0L7u3U/e3/5bvJdoo+L q9VpEoVYC1ef/toeNdy/ffvH5GP+7/XnXbz/9+b3ycd7c3u7+Sn+vDg/F4rXJOK1dZ0o/nlUqA+2 3ueKfx7fCexvtm7TVv+qtGlb3IcBAMjCVVIO2sY1Jhzx5l+ReLlKaiQ6gU/89NPRIGE4kqnEjQHy aSNfjIAGGAkkDDw1aLQR2KAqIIWEAUH0MYBDYNDbgd75VLF4o2gbLBcziQ5V9DCcSCWNuPlLbcxb ZYhIcxBDKl8w6D0Oehh4wj6HLeoCEuhhgLYBDdQJpJAwoGd7+kHmJR683QfHgVNS0D2eVAmbG/dw JOhhoPZ42+njGrQx0CtCEwkDahdJYQzkCySQMLBDH8OTVswkC6SQMKBH7pwUzS+OAwkD6wZN6HwU YxhjIMmhiYQBtTFvjIExDCSQMLDCGXZPek0vyQIpJAzoIV8AB8GNewCALPQwsHrSp9I9GHQwRsCV XUggYWCF5gFl1AekkDAgiD4GcAgkDOghXwAHQcKA3NvKyBf+eIMdUrhKCgCQhR4GBNHHAA6BhAE5 ii/cM9IGjgAJA7vz1SFovRGDF+75YQwDKYxhYIdGAkAXEgYAIAunpCBndwpNJaqK6rkAAABwSURB VPAYGb/AUaCHAVmMYQDjImEAALKQMAAAWRjDgBy5R5lw9RmOBD0MAEAWEgYAIAsJA3JUT/Fwagrq GMOAJKXGl0SBY0EPAwCQRaWHcT+BGIZ4MLOlmT0Sr4vHTbwPxOtmKbbfKcYLAMARMrP/B+v41b3+ LPIjAAAAAElFTkSuQmCC",
    transform: "matrix(0.2406 0 0 0.2406 1.68 1.6)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.2,53.5h-0.7c-0.2,0-0.3-0.1-0.3-0.3s0.2-0.3,0.3-0.3h0.7c0.2,0,0.3,0.1,0.3,0.3S26.4,53.5,26.2,53.5z  M79.5,53.2c0-0.2-0.2-0.3-0.3-0.3h-1.3c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h1.3C79.3,53.5,79.5,53.3,79.5,53.2z M75.9,53.2 c0-0.2-0.2-0.3-0.3-0.3h-1.3c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h1.3C75.8,53.5,75.9,53.3,75.9,53.2z M72.4,53.2 c0-0.2-0.2-0.3-0.3-0.3h-1.3c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h1.3C72.3,53.5,72.4,53.3,72.4,53.2z M68.9,53.2 c0-0.2-0.2-0.3-0.3-0.3h-1.3c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h1.3C68.7,53.5,68.9,53.3,68.9,53.2z M65.4,53.2 c0-0.2-0.2-0.3-0.3-0.3h-1.3c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3H65C65.2,53.5,65.4,53.3,65.4,53.2z M61.8,53.2 c0-0.2-0.2-0.3-0.3-0.3h-1.3c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h1.3C61.7,53.5,61.8,53.3,61.8,53.2z M58.3,53.2 c0-0.2-0.2-0.3-0.3-0.3h-1.3c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3H58C58.2,53.5,58.3,53.3,58.3,53.2z M54.8,53.2 c0-0.2-0.2-0.3-0.3-0.3h-1.3c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h1.3C54.6,53.5,54.8,53.3,54.8,53.2z M51.3,53.2 c0-0.2-0.2-0.3-0.3-0.3h-1.3c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3H51C51.1,53.5,51.3,53.3,51.3,53.2z M47.7,53.2 c0-0.2-0.2-0.3-0.3-0.3h-1.3c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h1.3C47.6,53.5,47.7,53.3,47.7,53.2z M44.2,53.2 c0-0.2-0.2-0.3-0.3-0.3h-1.3c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h1.3C44.1,53.5,44.2,53.3,44.2,53.2z M40.7,53.2 c0-0.2-0.2-0.3-0.3-0.3H39c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h1.3C40.5,53.5,40.7,53.3,40.7,53.2z M37.2,53.2 c0-0.2-0.2-0.3-0.3-0.3h-1.3c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h1.3C37,53.5,37.2,53.3,37.2,53.2z M33.6,53.2 c0-0.2-0.2-0.3-0.3-0.3H32c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h1.3C33.5,53.5,33.6,53.3,33.6,53.2z M30.1,53.2 c0-0.2-0.2-0.3-0.3-0.3h-1.3c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3h1.3C30,53.5,30.1,53.3,30.1,53.2z M82.3,53.2 c0-0.2-0.2-0.3-0.3-0.3h-0.7c-0.2,0-0.3,0.1-0.3,0.3s0.2,0.3,0.3,0.3H82C82.2,53.5,82.3,53.3,82.3,53.2z M75.8,84.5v-1.3 c0-0.2-0.2-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v1.3c0,0.2,0.2,0.3,0.3,0.3C75.7,84.8,75.8,84.6,75.8,84.5z M75.8,80.9v-1.3 c0-0.2-0.2-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v1.3c0,0.2,0.2,0.3,0.3,0.3C75.7,81.3,75.8,81.1,75.8,80.9z M75.8,77.4v-1.3 c0-0.2-0.2-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v1.3c0,0.2,0.2,0.3,0.3,0.3C75.7,77.8,75.8,77.6,75.8,77.4z M75.8,73.9v-1.3 c0-0.2-0.2-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v1.3c0,0.2,0.2,0.3,0.3,0.3C75.7,74.2,75.8,74.1,75.8,73.9z M75.8,70.4v-1.3 c0-0.2-0.2-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v1.3c0,0.2,0.2,0.3,0.3,0.3C75.7,70.7,75.8,70.6,75.8,70.4z M75.8,66.9v-1.3 c0-0.2-0.2-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v1.3c0,0.2,0.2,0.3,0.3,0.3C75.7,67.2,75.8,67.1,75.8,66.9z M75.8,63.4v-1.3 c0-0.2-0.2-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v1.3c0,0.2,0.2,0.3,0.3,0.3C75.7,63.7,75.8,63.6,75.8,63.4z M75.8,59.9v-1.3 c0-0.2-0.2-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v1.3c0,0.2,0.2,0.3,0.3,0.3C75.7,60.2,75.8,60,75.8,59.9z M75.8,56.3V55 c0-0.2-0.2-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v1.3c0,0.2,0.2,0.3,0.3,0.3C75.7,56.7,75.8,56.5,75.8,56.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074429516039910065670000007078564603069696400_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.0571,
    y1: 48.01,
    x2: 23.264,
    y2: 48.01,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA7802"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06362359,
    style: {
      stopColor: "#C1820F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1824,
    style: {
      stopColor: "#D49E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3422,
    style: {
      stopColor: "#F1C96B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4089,
    style: {
      stopColor: "#FFDD85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4219,
    style: {
      stopColor: "#FFDE89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#FFE296"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#FFE7AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4643,
    style: {
      stopColor: "#FFEFC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4669,
    style: {
      stopColor: "#FFF1CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#FFEAB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    style: {
      stopColor: "#FFE39B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5243,
    style: {
      stopColor: "#FFDF8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    style: {
      stopColor: "#FFDD85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5752,
    style: {
      stopColor: "#F6CF73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6672,
    style: {
      stopColor: "#E0B04B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#D0982B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8447,
    style: {
      stopColor: "#C48614"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    style: {
      stopColor: "#BC7C07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7802"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074429516039910065670000007078564603069696400_)"
    },
    d: "M22.7,84.9c-0.3,0-0.6-0.3-0.6-0.6V19.7 c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6v64.7C23.3,84.7,23,84.9,22.7,84.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036954452735555915860000000599304794123319706_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.1228,
    y1: 48.01,
    x2: 43.3297,
    y2: 48.01,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA7802"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06362359,
    style: {
      stopColor: "#C1820F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1824,
    style: {
      stopColor: "#D49E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3422,
    style: {
      stopColor: "#F1C96B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4089,
    style: {
      stopColor: "#FFDD85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4219,
    style: {
      stopColor: "#FFDE89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#FFE296"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#FFE7AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4643,
    style: {
      stopColor: "#FFEFC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4669,
    style: {
      stopColor: "#FFF1CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#FFEAB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    style: {
      stopColor: "#FFE39B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5243,
    style: {
      stopColor: "#FFDF8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    style: {
      stopColor: "#FFDD85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5752,
    style: {
      stopColor: "#F6CF73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6672,
    style: {
      stopColor: "#E0B04B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#D0982B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8447,
    style: {
      stopColor: "#C48614"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    style: {
      stopColor: "#BC7C07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7802"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036954452735555915860000000599304794123319706_)"
    },
    d: "M42.7,84.9c-0.3,0-0.6-0.3-0.6-0.6V19.7 c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v64.7C43.3,84.7,43.1,84.9,42.7,84.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173856667397077982190000009640543918926256539_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.0528,
    y1: 48.01,
    x2: 62.2597,
    y2: 48.01,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA7802"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06362359,
    style: {
      stopColor: "#C1820F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1824,
    style: {
      stopColor: "#D49E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3422,
    style: {
      stopColor: "#F1C96B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4089,
    style: {
      stopColor: "#FFDD85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4219,
    style: {
      stopColor: "#FFDE89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#FFE296"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#FFE7AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4643,
    style: {
      stopColor: "#FFEFC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4669,
    style: {
      stopColor: "#FFF1CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#FFEAB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    style: {
      stopColor: "#FFE39B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5243,
    style: {
      stopColor: "#FFDF8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    style: {
      stopColor: "#FFDD85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5752,
    style: {
      stopColor: "#F6CF73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6672,
    style: {
      stopColor: "#E0B04B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#D0982B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8447,
    style: {
      stopColor: "#C48614"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    style: {
      stopColor: "#BC7C07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7802"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173856667397077982190000009640543918926256539_)"
    },
    d: "M61.7,84.9c-0.3,0-0.6-0.3-0.6-0.6V19.7 c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v64.7C62.3,84.7,62,84.9,61.7,84.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006698081578305232460000014419824403018225842_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.6687,
    y1: 54.51,
    x2: 49.541,
    y2: 54.51,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA7802"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06362359,
    style: {
      stopColor: "#C1820F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1824,
    style: {
      stopColor: "#D49E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3422,
    style: {
      stopColor: "#F1C96B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4089,
    style: {
      stopColor: "#FFDD85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4219,
    style: {
      stopColor: "#FFDE89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#FFE296"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#FFE7AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4643,
    style: {
      stopColor: "#FFEFC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4669,
    style: {
      stopColor: "#FFF1CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#FFEAB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    style: {
      stopColor: "#FFE39B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5243,
    style: {
      stopColor: "#FFDF8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    style: {
      stopColor: "#FFDD85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5752,
    style: {
      stopColor: "#F6CF73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6672,
    style: {
      stopColor: "#E0B04B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#D0982B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8447,
    style: {
      stopColor: "#C48614"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    style: {
      stopColor: "#BC7C07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7802"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.7,
    y: 32.5,
    style: {
      fill: "url(#SVGID_00000006698081578305232460000014419824403018225842_)"
    },
    width: 12.9,
    height: 26
  }))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 53,
    height: 107,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAABqCAYAAADz/HJsAAAACXBIWXMAAC02AAAtNgEvpe6OAAAE +ElEQVR4nO2b226kQAxEu5m87v9/LbCKNCBTVLltLhlIsIS4DASfrrK7Z1ZbnnjiiSeeeOKJJ554 4okn/lbU91a6X4Bd7cndgSpeuDPQCqbcGAhh5vM7AkmYckMgF6bcDMiDuV3bbsHM8fVzOW2OCMxt mkIU5hZAGZgZ6qqWi8B05nz+/IpAkW6GUN/7oVwQKAODdrtc294DM3NcBWgLTAf7yzSFKAzbEOrj Ch0FcwmgI2Gm7WNAZ8B8TKEzYGagn24KR8O8PqnQWcqsFPo+GC8Og0AvcbxY4N0Z5sUsV08AO8Jm CgavyRo6CurMBjCdr5qCqqHp5Vtr66dsJhVSdttiw0/ASIWUMpFOqAYkAsPWZaqTMZgV0BQWTNkQ gZWCGWX2wkggm7BXRy0bVrJvgbQ2D8YFGkGhTINAVfbCeDWDMK5CCBgB2wqjwNIwE1D3TpIlyqyX sVt0jlHzDc41CmYBxNosNodWTTEQBpWF8ezIBmulkFKKKaagjoRp2Ww1TzKgwVHKm4+8zpatlxZM B+9aAL3eEFadllItoIw6WRgcuClGqxBCoAUzLftsmJXNbH6TQtWoVEEx3FhziKrjLf+j3YzBjKhQ BRClkv2MdcdCEpjOT4eZgL7eINMDLZVQHQsUWQ149nrBM1EYqVAlcAjmAaFCnt2OhBks0AsgUKXq KOUppJqBst4emBVQJ2ynYKKWU3XB4OoOmKZCnu1allOTaavw98CsgBDCqjQSpVRE558MDOu6CDPY f5LEts2AuqDlCoFhUOyeCIxVYzruUaHOJN9SJgvErOeBbIWhNcQ6GwMqBArrhzUGBlrh2a0wvQWq YCnbCDwgu28BseOtMD3UTc9qiFnKm39UY2BACgZB9sAsFLKJePbKtm1VH6wlezBsQ7stagj/eBVA eOwpxMAQmg2MVzOqdlZNgY0ye6l9OSbCnlN7FpE5hoE0gVSCo7BJ5Fm8plSJwGAN0ZUC61Rekhmg YgYEz1tLGQ+GgS2A2ITagvEgW0Vvr7UaQBRmBhpE4arjjIJWfQRRRZ9VhgJ1IslRwHpQyl7lBJsN MDgz0EhmdEwyar1K7MVAlEoI4zWCAQZsYbliYAaAq2CfTLAJ80iYleV6oohVCWvMs1iBa/hChPCs lYaxQNOH9quEsqG1oNcMjqqXngwEwqwUGmGRapNnNkR12KoiApSZYzyYOSwQQo1GiRHqqbU2y6rD QDLKzFDfX+7+OTXAagJHZTpWL1LzTctiWZiV5ezWAQB+Te+IOnvqhykUsRnuJdBgvjrb8xps4RGF vJphQK4yFmggSWAt4apBtXKlktd+Iy25BUMV6iABVGeELpf5Go2j3cO1ntwbqhmlECrh/WiC9ROp IVSJqRYBcWEKLH0UiGe3LROrKva9MHOXG6DYcbVQje22WM6zXhSkqQxTiK0IRnMda6iQvX2RAvKO t8IsmoICqOQ6U8iCeUAKzl5jz4VhCvymgImoHwa3KlQaQOy+FAwCjZDsNGJKmUgNseSUErthEAhv VnbzYBQYS9iDQKVDMFNCL3PM5hfvGoNiybQSZ6qkYaZk2EIzu/dequzTshar7WZ8ZW6GP14Dz3mJ HqaKDTXjt2rFqx0vmRbALphi/8/AOyIWyobqVC2QTe9V67E917xkMgpsGsRI+43CqcjaaI8bQnZT 92+J00BaCe5NPBuHwPy+KKX8B9bNVkn8dM7DAAAAAElFTkSuQmCC",
    transform: "matrix(0.2445 0 0 0.2445 36.6011 32.44)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.8,13.8c-0.9,0-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6H77L41.8,51.3L24,39.9c-0.7-0.5-1.7-0.3-2.2,0.5 c-0.5,0.7-0.3,1.7,0.5,2.2l20,12.8l36.6-35.8v6.3c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6V13.8H69.8z"
  }))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 251,
    height: 173,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPkAAACtCAYAAAByUNlxAAAACXBIWXMAAC3UAAAt1AEYYcVpAAAD L0lEQVR4nO3csY8UVRzA8fd299aN5Lypr6KRGhLpzwYoaQ3N3l8AlhBNkAiJlXQam91YE4mFBim4 U3uPAuzQArG4YM7cJbfJMTPP3MlFDZwWsruzbz+fv+Dl95tvXmaKCQAAAAAAAAAAAAAAAAAAAAAA AAAAAHMPAAAAAAAAAAAAAAAAgHFLKRWzPORWA84AjVXXdT+EcGmWNyRyOMLe3l4/pTSY9fmIHF5i Z2cni8CDyOFFm5ub/bquswh8X6cBZ4DGePTop0FVHbyHZ8NNDs/9sHF/8PxDW1ZEDiGEe/fWBynD wIPIIYRbt77I8gY/JHLm2ieffjaoMg48iJx59sG1DwdVVWUdeBA58yy3r+hHETlkTuSQOZFD5kQO mRM5ZE7kkDmRQ+ZEDv/t91mekcjh3w1jjDdneUYihyOklIbtdnt11ucjcniJ/cB7vd7MBx5EDi9K qR4WRZFF4EHk8E/7N/jy8nI2gQeRw1/qun73xIk3swo8+JEj/KmsytXTp98a5jgONzlzr3z2bPXc 2TNZBh5Ezrwry3L1woV3sg0c5trlK+/PxZ9hAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsnX5ynvnr9/4qLBhmIzWpOccY7zY6722MRh+vmLHMH4T j3xfDPF4p9NZ++rrO4Nvv/verQ5jNJXID8UY+91u9+cHD388b8kwHlONPBzc6qFot1q3Hz/+Ze3p 09+OT/s8kJupR34oxrjSarU2dnd3LzXjRJCHxkQeDkIPRYzx47IsN+q6PtmAI8HMa1Tkf3NyP/bG nAZmWFMjB14RkUPmRA6ZEzlkTuSQOZFD5kQOmRM5ZG4KkccvPVQwOROP/Mb1aze73e6pGON9e4bx i9Oc8Z1v7l4tloqLS0tvFIuLi+HYsddDr9cLCwsLod1ur8cY3/YMwP8z1Xfyc2fPXO10OqdCjOv2 CJl78uTX/tbW1tZoNEplWaaU0pqdQ2a2t7eL0Wh0W+SQuaqqVlJKA3sGAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAgFcthPAHI7vB/wYdPoQAAAAASUVORK5CYII=",
    transform: "matrix(0.2414 0 0 0.2414 21.4259 13.72)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168099573286794491170000011379214422092135334_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.6,
    y1: 40.91,
    x2: 29.4723,
    y2: 40.91,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA7802"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06362359,
    style: {
      stopColor: "#C1820F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1824,
    style: {
      stopColor: "#D49E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3422,
    style: {
      stopColor: "#F1C96B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4089,
    style: {
      stopColor: "#FFDD85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4219,
    style: {
      stopColor: "#FFDE89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#FFE296"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#FFE7AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4643,
    style: {
      stopColor: "#FFEFC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4669,
    style: {
      stopColor: "#FFF1CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#FFEAB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    style: {
      stopColor: "#FFE39B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5243,
    style: {
      stopColor: "#FFDF8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    style: {
      stopColor: "#FFDD85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5752,
    style: {
      stopColor: "#F6CF73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6672,
    style: {
      stopColor: "#E0B04B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#D0982B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8447,
    style: {
      stopColor: "#C48614"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    style: {
      stopColor: "#BC7C07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7802"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.6,
    y: 39.2,
    style: {
      fill: "url(#SVGID_00000168099573286794491170000011379214422092135334_)"
    },
    width: 12.9,
    height: 39.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006708046799767281070000006060534028570477963_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.6,
    y1: 52.46,
    x2: 68.4723,
    y2: 52.46,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA7802"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06362359,
    style: {
      stopColor: "#C1820F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1824,
    style: {
      stopColor: "#D49E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3422,
    style: {
      stopColor: "#F1C96B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4089,
    style: {
      stopColor: "#FFDD85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4219,
    style: {
      stopColor: "#FFDE89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    style: {
      stopColor: "#FFE296"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#FFE7AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4643,
    style: {
      stopColor: "#FFEFC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4669,
    style: {
      stopColor: "#FFF1CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4831,
    style: {
      stopColor: "#FFEAB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    style: {
      stopColor: "#FFE39B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5243,
    style: {
      stopColor: "#FFDF8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    style: {
      stopColor: "#FFDD85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5752,
    style: {
      stopColor: "#F6CF73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6672,
    style: {
      stopColor: "#E0B04B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#D0982B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8447,
    style: {
      stopColor: "#C48614"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    style: {
      stopColor: "#BC7C07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BA7802"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 55.6,
    y: 24.3,
    style: {
      fill: "url(#SVGID_00000006708046799767281070000006060534028570477963_)"
    },
    width: 12.9,
    height: 46.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.9,76.4L131,42.2v34.1c0,0.8-0.6,1.3-1.4,1.3h-8.7c-0.8,0-1.4-0.6-1.4-1.3V21.8c0-0.8,0.7-1.3,1.4-1.3 h10.4c1.1,0,1.8,0.3,2.2,1.2l19.2,40.2l19.2-40.2c0.4-0.9,1.2-1.2,2.2-1.2h9.1c0.8,0,1.4,0.6,1.4,1.3v54.5c0,0.8-0.6,1.3-1.4,1.3 h-8.7c-0.8,0-1.4-0.6-1.4-1.3V42.2l-16.8,34.2c-0.4,0.9-1.1,1.3-2.1,1.3h-4.3C148.9,77.6,148.3,77.2,147.9,76.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.5,77.4c-1,1-2.9,1.3-4.7,0l-3-2.4c-4.4,2.6-7.4,3.4-11.1,3.4c-7.6,0-12.4-3.9-12.4-10.9 c0-5.3,4.4-10,13.8-10h6.7v-0.9c0-3.2-1.7-4.6-5-4.6c-3.6,0-7.5,1.3-11.1,2.8c-1.1,0.4-1.5,0.1-1.9-1l-2.2-5.5 c-0.4-1.1,0-1.8,1.2-2.3c4.1-2,9.4-3.8,16-3.8c8.9,0,14.6,3.4,14.6,14v10.8c0,1.3,0.2,1.8,1,2.4l2.4,1.8c0.9,0.6,0.8,1.6,0.2,2.2 L224.5,77.4z M213.8,69.2v-6.3h-4.3c-3.8,0-5.2,1.4-5.2,4c0,2.4,1.6,3.9,4.7,3.9C210.6,70.7,212,70.3,213.8,69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235,44.4c0-0.8,0.6-1.4,1.4-1.4h8.6c0.9,0,1.4,0.6,1.4,1.4v3.4c2.6-3.4,5.5-5.7,9.8-5.7 c1.8,0,3.4,0.2,4.5,0.8c1.1,0.5,0.9,1.3,0.8,2l-1.8,7.4c-0.3,1-0.9,1.2-2,0.8c-1.3-0.3-2.9-0.7-4.8-0.7c-2.7,0-4.6,0.8-6.5,2.4 v21.4c0,0.8-0.5,1.4-1.4,1.4h-8.6c-0.8,0-1.4-0.6-1.4-1.4V44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284,69.1c1.6,0,3-0.5,4.2-1.1c0.9-0.5,1.5-0.3,1.9,0.7l2.1,5.9c0.3,0.8,0.3,1.3-0.7,1.8 c-2.3,1.3-5.7,2.2-9.5,2.2c-8.4,0-12.5-4-12.5-12.8V52.1h-3.9c-0.9,0-1.5-0.5-1.5-1.3v-6.5c0-0.8,0.6-1.4,1.5-1.4h3.9v-9.1 c0-0.8,0.6-1.4,1.5-1.4h8.6c0.8,0,1.4,0.6,1.4,1.4v9.1h8.4c0.9,0,1.5,0.7,1.5,1.4v6.5c0,0.8-0.6,1.3-1.5,1.3h-8.4v12.8 C281.1,67.8,282,69.1,284,69.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.7,78.5c-13.2,0-20.7-6.6-20.7-18.2c0-11.6,7.5-18.2,18.7-18.2c10.2,0,16.9,6.5,16.9,16.2 c0,0.8,0,2.3-0.2,3.2c-0.2,0.8-0.7,1-1.5,1H308c1,4.6,4.5,7.1,9.7,7.1c4.7,0,8.5-1.5,10.9-2.3c1.1-0.3,1.6-0.2,2,0.8l1.8,5.5 c0.3,0.7,0.3,1.3-0.8,1.8C328.1,77.5,322.6,78.5,316.7,78.5z M308,56.9h12.8c-0.6-4.4-2.9-6.2-6.2-6.2 C311.2,50.7,308.8,53.1,308,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.9,77.6h-7.5c-1.6,0-2.1-1.1-0.8-2.7l11.9-15.5l-10.4-14c-1.1-1.4-0.7-2.6,1.1-2.6h8.8 c1.5,0,2.4,0.5,3.3,1.8l5.1,7.8l5.2-7.8c0.9-1.3,1.8-1.8,3.3-1.8h8.2c1.7,0,2.1,1.2,1,2.6l-10.7,13.9l11.7,15.5 c1.2,1.6,0.7,2.7-0.9,2.7h-8.8c-1.5,0-2.5-0.6-3.4-1.8l-6.8-10l-6.9,10C347.5,77,346.5,77.6,344.9,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.1,30.6h-17.5c-0.8,0-1.3-0.6-1.3-1.3v-7.3c0-0.9,0.5-1.4,1.3-1.4h47.1c0.8,0,1.4,0.5,1.4,1.4v7.3 c0,0.8-0.6,1.3-1.4,1.3h-17.5v45.7c0,0.8-0.6,1.3-1.4,1.3h-9.2c-0.8,0-1.4-0.6-1.4-1.3V30.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.4,44.4c0-0.8,0.6-1.4,1.4-1.4h8.6c0.9,0,1.4,0.6,1.4,1.4v3.4c2.6-3.4,5.5-5.7,9.8-5.7 c1.8,0,3.4,0.2,4.5,0.8c1.1,0.5,0.9,1.3,0.8,2l-1.8,7.4c-0.3,1-0.9,1.2-2,0.8c-1.3-0.3-2.9-0.7-4.8-0.7c-2.7,0-4.6,0.8-6.5,2.4 v21.4c0,0.8-0.5,1.4-1.4,1.4h-8.6c-0.8,0-1.4-0.6-1.4-1.4V44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M486.7,77.4c-1,1-2.9,1.3-4.7,0l-3-2.4c-4.4,2.6-7.4,3.4-11.1,3.4c-7.6,0-12.4-3.9-12.4-10.9 c0-5.3,4.4-10,13.8-10h6.7v-0.9c0-3.2-1.7-4.6-5-4.6c-3.6,0-7.5,1.3-11.1,2.8c-1.1,0.4-1.5,0.1-1.9-1l-2.2-5.5 c-0.4-1.1,0-1.8,1.2-2.3c4.1-2,9.4-3.8,16-3.8c8.9,0,14.6,3.4,14.6,14v10.8c0,1.3,0.2,1.8,1,2.4l2.4,1.8c0.9,0.6,0.8,1.6,0.2,2.2 L486.7,77.4z M476,69.2v-6.3h-4.3c-3.8,0-5.2,1.4-5.2,4c0,2.4,1.6,3.9,4.7,3.9C472.9,70.7,474.2,70.3,476,69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M530.9,77.6h-8.6c-0.9,0-1.4-0.6-1.4-1.4v-1.9c-2.5,2.6-5.8,4.2-10.7,4.2c-8.7,0-15.5-5.6-15.5-18.2 c0-11.7,6.2-18.2,15.5-18.2c3.8,0,7.6,1.3,10.6,3.7v-24c0-0.8,0.5-1.3,1.4-1.3h8.6c0.8,0,1.4,0.6,1.4,1.3v54.4 C532.4,77,531.8,77.6,530.9,77.6z M507,60.3c0,5.2,2.4,8.7,6.8,8.7c2.6,0,4.9-1.2,7.1-3.7V55.1c-2.3-2.4-4.5-3.5-7.3-3.5 C509.3,51.6,507,55,507,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M559.8,78.5c-13.2,0-20.7-6.6-20.7-18.2c0-11.6,7.5-18.2,18.7-18.2c10.2,0,16.9,6.5,16.9,16.2 c0,0.8,0,2.3-0.2,3.2c-0.2,0.8-0.7,1-1.5,1h-21.9c1,4.6,4.5,7.1,9.7,7.1c4.7,0,8.5-1.5,10.9-2.3c1.1-0.3,1.6-0.2,2,0.8l1.8,5.5 c0.3,0.7,0.3,1.3-0.8,1.8C571.2,77.5,565.6,78.5,559.8,78.5z M551.1,56.9h12.8c-0.6-4.4-2.9-6.2-6.2-6.2 C554.3,50.7,551.9,53.1,551.1,56.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhitefont);
export default __webpack_public_path__ + "static/media/logo-white font.30e9c26200a7a563979129ffad5c8d9c.svg";
export { ForwardRef as ReactComponent };